import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  active: false,
  results: [],
  loading: false,
  searchVal: "",
};

const searchSlice = createSlice({
  name: "search",
  initialState: initialState,
  reducers: {
    changeState: (state, action) => {
      return { ...state, active: action.payload };
    },
    storeSearchResults: (state, action) => {
      return { ...state, results: action.payload };
    },
    changeLoading: (state, action) => {
      return { ...state, loading: action.payload };
    },
    storeSearchVal: (state, action) => {
      return { ...state, searchVal: action.payload };
    },
    removeSearchResult: (state, action) => {  
      return {  
        ...state,  
        results: state.results.filter(item => item.id !== action.payload),  
      };  
    },
  },
});

export const {
  changeState,
  storeSearchResults,
  changeLoading,
  storeSearchVal,
  removeSearchResult,
} = searchSlice.actions;
export default searchSlice.reducer;
